
import { Box, Button, Stack, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { useQueryClient } from "@tanstack/react-query";
import { SurveySectionHeader } from "components/screen/phase-3/supplier/PreviewDrawer";
import QuestionBody from "../surveyQuestions/QuestionComponents/right/QuestionBody";

const responseStyles = makeStyles((theme) => ({
  questionContainer: {
    border: `1px solid var(--scroll-box-border-color)`,
    borderRadius: 8,
    height: "calc(100vh - 260px)",
    overflowX: "auto",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: 10,
      height: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#fbfbfb",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#e9e9e9",
      borderRadius: 4,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#bbbbbb",
    },
  },
  question: {
    fontSize: 14,
    fontWeight: 400,
    padding: "12px 8px",
    wordBreak: "break-all",
    border: "1px solid #E9E9E9",
    backgroundColor: "#FCFCFC",
    borderRadius: "6px",
    marginLeft: 5,
    width: "80%",
  },
  weightage: {
    fontSize: 13,
    fontWeight: 400,
    padding: "5px 6px",
    wordBreak: "break-all",
    color: "#3374B9",
    border: "1px solid #EBF1F8",
    backgroundColor: "#EBF1F8",
    borderRadius: "16px",
    marginLeft: 5,
    width: "18%",
    textAlign: "center",
    height: "fit-content",
  },
  userName: {
    padding: 6,
    margin: "8px 5px",
    fontSize: 13,
    borderRadius: 5,
    cursor: "pointer",
  },
}));

export const getQuestionsToRender = (surveySectionQuestions, surveyData) => {
  const updateQuestionList = surveySectionQuestions.filter((question) => {
    if (question?.linked_question_id) {
      const findParentQuestion = surveySectionQuestions.find(
        (q) => q?._id === question?.linked_question_id
      );

      const hasDataUpdated = surveyData.find(
        (s) => s?.question_id === findParentQuestion?._id
      );

      const getMultichoice = (options = []) => {
        const getLogic = options?.find(
          (o) =>
            o?.checked &&
            o?.answerLogic?.find((f) => f?.linked_question_id === question?._id)
        );

        return getLogic?.answerLogic[0] || {};
      };

      if (hasDataUpdated) {
        const findLogic =
          findParentQuestion?.questionType === "MULTICHOICE"
            ? getMultichoice(hasDataUpdated?.submitted_answer?.options)
            : hasDataUpdated?.answers?.answerLogic?.find(
                (f) => f?.linked_question_id === question?._id
              );

        return findLogic?.action === "show" ? true : false;
      } else if (findParentQuestion?.submitted_answer) {
        const findLogic =
          findParentQuestion?.questionType === "MULTICHOICE"
            ? getMultichoice(findParentQuestion?.submitted_answer?.options)
            : findParentQuestion?.submitted_answer?.answerLogic?.find(
                (f) => f?.linked_question_id === question?._id
              );

        return findLogic?.action === "show" ? true : false;
      } else {
        return false;
      }
    }

    return true;
  });

  // console.log(updateQuestionList.filter((q, i, a) => q?.linked_question_id ? a.some(a => a?._id === q?.linked_question_id) : q))

  return updateQuestionList.filter((q, i, a) =>
    q?.linked_question_id ? a.some((a) => a?._id === q?.linked_question_id) : q
  );
};

function QuestionsList({
  selectedSection = {},
  surveyData = [],
  handleQuesAnswer = () => {},
  handleAllSubmitResponse = () => {},
  surveySectionQuestions = [],
  disable,
  unansweredMandatoryIds = [],
  handleSectionChangeSave = () => {},
}) {
  const classes = responseStyles();

  // Get questions to render based on current section's visibility
  // const getQuestionsToRender = () => {
  //   const updateQuestionList = surveySectionQuestions.filter((question) => {
  //     if (question?.linked_question_id) {
  //       const findParentQuestion = surveySectionQuestions.find(
  //         (q) => q?._id === question?.linked_question_id
  //       );

  //       const hasDataUpdated = surveyData.find(
  //         (s) => s?.question_id === findParentQuestion?._id
  //       );

  //       const getMultichoice = (options = []) => {
  //         const getLogic = options?.find(
  //           (o) =>
  //             o?.checked &&
  //             o?.answerLogic?.find(
  //               (f) => f?.linked_question_id === question?._id
  //             )
  //         );

  //         return getLogic?.answerLogic[0] || {};
  //       };

  //       if (hasDataUpdated) {
  //         const findLogic =
  //           findParentQuestion?.questionType === "MULTICHOICE"
  //             ? getMultichoice(hasDataUpdated?.submitted_answer?.options)
  //             : hasDataUpdated?.answers?.answerLogic?.find(
  //                 (f) => f?.linked_question_id === question?._id
  //               );

  //         return findLogic?.action === "show" ? true : false;
  //       } else if (findParentQuestion?.submitted_answer) {
  //         const findLogic =
  //           findParentQuestion?.questionType === "MULTICHOICE"
  //             ? getMultichoice(findParentQuestion?.submitted_answer?.options)
  //             : findParentQuestion?.submitted_answer?.answerLogic?.find(
  //                 (f) => f?.linked_question_id === question?._id
  //               );

  //         return findLogic?.action === "show" ? true : false;
  //       } else {
  //         return false;
  //       }
  //     }

  //     return true;
  //   });

  //   return updateQuestionList;
  // };

  const queryClient = useQueryClient();
  const allSections =
    queryClient.getQueryCache().find({ queryKey: ["sections"], exact: false })
      ?.state?.data?.result || [];
  const currentIndex = allSections.findIndex(
    (s) => s?._id === selectedSection?._id
  );

  const isLastSection = currentIndex === allSections.length - 1;

  return (
    <Box width={"80%"}>
      <SurveySectionHeader
        title={selectedSection?.title}
        description={selectedSection?.description}
      />

      <Box className={classes.questionContainer}>
        {getQuestionsToRender(surveySectionQuestions, surveyData)?.map(
          (ques) => {
            const hasResponseUpdate =
              surveyData.find((s) => s.question_id === ques?._id) || null;
            const hadnleResponseShow = hasResponseUpdate
              ? hasResponseUpdate
              : ques;

            // for sub section

            if (ques?.questionType === "SUB_SECTION") {
              return (
                <Box key={ques._id}>
                  <SurveySectionHeader
                    title={ques.question}
                    description={ques.description}
                  />
                </Box>
              );
            }

            return (
              <Box
                key={ques._id}
                id={ques._id}
                m={2}
                sx={{
                  border: unansweredMandatoryIds.includes(ques._id)
                    ? "2px solid red"
                    : "1px solid #ddd",
                  borderRadius: 2,
                  p: 2,
                  mb: 2,
                  transition:
                    "border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography className={classes.question}>
                    {ques?.question}
                    {ques?.isMandatory && (
                      <Typography
                        component="span"
                        sx={{
                          color: "red",
                          ml: 0.5,
                          fontWeight: "bold",
                        }}
                      >
                        *
                      </Typography>
                    )}
                  </Typography>
                </Box>
                <Box ml={2}>
                  <QuestionBody
                    question={ques}
                    questionId={ques?._id}
                    questionType={ques?.questionType}
                    answers={ques?.answers}
                    submittedAnswer={
                      ques?.tableRows?.length > 0 ||
                      ques?.tableHeaders?.length > 0
                        ? hadnleResponseShow?.submitted_answer || []
                        : hadnleResponseShow?.submitted_answer
                          ? [hadnleResponseShow?.submitted_answer]
                          : []
                    }
                    submittedFiles={
                      ques?.submitted_answer?.documents ||
                      ques?.submission?.files
                    }
                    handleQuesAnswer={handleQuesAnswer}
                    removeEditOption={ques?.questionType === "MULTICHOICE"}
                    isFrom={
                      disable
                        ? ques?.questionType === "DOCUMENT_UPLOAD"
                          ? "surveyResponse"
                          : "publishedSurvey"
                        : "taskSection"
                    }
                    comment={ques?.showComment}
                    hasAttachedDocument={ques?.showDocument}
                    tableHeadersApi={ques?.tableHeaders}
                    tableRowsApi={ques?.tableRows}
                    calculation={{
                      resolved_custom_calculation_logic:
                        ques?.resolved_custom_calculation_logic,
                      custom_calculation_logic: ques?.custom_calculation_logic,
                    }}
                  />
                </Box>
              </Box>
            );
          }
        )}
      </Box>

      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          position: "absolute",
          gap: 2,
          mt: 1,
          mb: 4,
          right: 40,
          bottom: 0,
        }}
      >
        <Button
          variant="text"
          disabled={disable || currentIndex === 0}
          onClick={() => {
            const prevSection = allSections[currentIndex - 1];
            if (prevSection) handleSectionChangeSave(prevSection);
          }}
        >
          Previous
        </Button>
        <Button
          disabled={disable}
          variant="contained"
          color="primary"
          onClick={() => {
            if (isLastSection) {
              handleAllSubmitResponse(true);
            } else {
              const nextSection = allSections[currentIndex + 1];
              if (nextSection) handleSectionChangeSave(nextSection);
            }
          }}
        >
          {isLastSection ? "Submit Survey" : "Save and Continue"}
        </Button>
      </Stack>
    </Box>
  );
}

export default QuestionsList;
